export const MENU_DROPDOWN_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.ChromeTemplateInterface.MenuDropdownElement';
